import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


/**
 * Valida el UIC de un envío
 */


@Component({
  selector: 'app-prepara-envio',
  templateUrl: './prepara-envio.component.html',
  styleUrls: ['./prepara-envio.component.scss']
})
export class PreparaEnvioComponent implements OnInit {

  @ViewChild('uicField') uicField!: ElementRef<HTMLInputElement>;

  uic: string = '';
  uicInput: string | null = null;
  uicError: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }


  ngOnInit(): void {
    // Suscribirse a los parámetros de la url
    this.activatedRoute.params.subscribe(({ uic }) => {
      this.uic = uic;
    })
  }


  limpiaUic() {
    // Limpia el campo uic del formulario  
    this.uicInput = '';
    this.uicError = false;

    // Devuelve el foco al campo
    setTimeout(() => this.uicField.nativeElement.focus(), 0);
  }


  //// AUX  ///
  validarLongitudUIC(valor: string) {
    if (valor.length === 13) {
      this.validarUic()
    }
  }

  validarUic() {
    if (this.uicInput) this.uicInput = this.uicInput.toUpperCase();

    if (this.uicInput !== this.uic) {
      this.uicError = true;
    } else {
      this.uicError = false;
      this.router.navigate([`/pda/prepara_envio2/${this.uic}`]);
    }
  }

}
